import { QuestionnaireAttachment } from './QuestionnaireAttachment'

export interface Questionnaire {
  questionnaireId?: number;
  name: string;
  description?: string;
  externalId?: string;
  sections: Section[];
  displayMode: DisplayMode;
  answerDateTime?: string;
}

export enum DisplayMode {
  COMBINED = 'COMBINED', BY_SECTION = 'BY_SECTION', BY_QUESTION = 'BY_QUESTION'
}

export interface Section {
  title?: string;
  externalId?: string;
  description?: string;
  questions: AnyQuestion[];
}

export interface Question<T = unknown> {
  label: string;
  type: QuestionType;
  externalId?: string;
  required?: boolean;
  description?: string;
  mandatoryImage?: boolean;
  image?: QuestionnaireAttachment;
  answer?: T;
  defaultValue?: T;
}

export enum QuestionType {
  TEXT = 'TEXT',
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  PRECISE_NUMBER = 'PRECISE_NUMBER',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  CHECKBOX = 'CHECKBOX',
  IMAGE = 'IMAGE'
}

export interface SelectQuestion<T = unknown> extends Question<T> {
  options: SelectOption[];
}

export interface SelectOption {
  value: string;
  type?: AnswerState;
  instruction?: string;
}

export interface TextQuestion extends Question<string> {
  type: QuestionType.TEXT;
}

export interface NumberQuestion extends Question<number> {
  type: QuestionType.NUMBER;
}

export interface SingleSelectQuestion extends SelectQuestion<string> {
  type: QuestionType.SELECT;
}

export interface MultiSelectQuestion extends SelectQuestion<string[]> {
  type: QuestionType.MULTISELECT;
}

export interface DateQuestion extends Question<string> {
  type: QuestionType.DATE;
}

export interface DateTimeQuestion extends Question<string> {
  type: QuestionType.DATETIME;
}

export interface ImageQuestion extends Question<QuestionnaireAttachment> {
  type: QuestionType.IMAGE;
}

export type AnyQuestion =
  | TextQuestion | NumberQuestion | SingleSelectQuestion | MultiSelectQuestion | DateQuestion | DateTimeQuestion | ImageQuestion;

export enum AnswerState {
  BASIC = 'BASIC', BLOCKING = 'BLOCKING', WARNING = 'WARNING'
}
